<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير التردد اليومى لحضور وغياب الطلاب'" :to="{name: 'reports.absences'}">  تقرير التردد اليومى لحضور وغياب الطلاب</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                            تقرير التردد اليومى لحضور وغياب الطلاب
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                      <div class="col-md-12 mt-2">
                                          <label for="">التاريخ</label>
                                          <date-picker v-model="data.searching.date" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">المرحلة الدراسية</label>
                                          <treeselect :options="stages" v-model="data.searching.stage_id" @select="getGroups($event); getLessons($event, false)" :multiple="false" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">الصف الدراسى</label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" @select="getLessons" :multiple="false" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">الحلقة</label>
                                          <treeselect :options="lessons" v-model="data.searching.lesson_id" @select="getStudents" :multiple="false" />
                                        </div>
                                        <div class="col-md-6 mt-2" style="display: none;">
                                          <label for="">الطالب </label>
                                          <treeselect :options="students" v-model="data.searching.student_id" :multiple="false" />
                                        </div>
                                       
                                        
                                        <div class="col-md-4 mt-4">
                                          <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="col-md-12">
                                  <button class="btn btn-success" v-if="data.data.data" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  <button class="btn btn-success ml-2" v-if="data.data.data" @click.prevent="exportExcel">
                                    تصدير Excel
                                  </button>
                                </div>
                                <div class="col-md-12" id="printMe">
                                  
                                    <div class="table-responsive" >
                                      <table class="table table-bordered mb-4" v-if="data.data.data">
                                              <thead>
                                                  <tr>
                                                    <th>اسم التقرير</th>
                                                    <th> تاريخ</th>
                                                    <th>المرحلة الدراسية</th>
                                                    <th>الصف الدراسى</th>
                                                    <th>الحلقة</th>
                                                    <th style="display: none;">االطالب</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                               <tr>
                                                <td> تقرير التردد اليومى لحضور وغياب الطلاب</td>
                                                <td>{{ data.searching.date }}</td>
                                                <td>{{ getLabelById(stages, data.searching.stage_id) }}</td>
                                                <td>{{ getLabelById(groups, data.searching.group_id) }}</td>
                                                <td>{{ getLabelById(lessons, data.searching.lesson_id) }}</td>
                                                <td style="display: none;">{{ getLabelById(students, data.searching.student_id) }}</td>
                                               </tr>
                                              </tbody>
                                          </table>
                                          <table class="table table-bordered mb-4" v-if="data.data.data">
                                              <thead>
                                                  <tr>
                                                    <th>إجمالى طلاب الحلقات </th>
                                                    <th>{{ data.data.total_students }}</th>
                                                    <th>طالب</th>
                                                    <th>#</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td>إجمالى الحضور</td>
                                                  <td>{{ data.data.main.pre }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(data.data.main.pre, data.data.total_students) }}%</td>
                                                </tr>
                                                <tr>
                                                  <td>إجمالى الغياب</td>
                                                  <td>{{ data.data.main.abs }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(data.data.main.abs, data.data.total_students) }}%</td>
                                                </tr>
                                                <tr>
                                                  <td>إجمالى الاستأذان</td>
                                                  <td>{{ data.data.main.exc }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(data.data.main.exc, data.data.total_students) }}%</td>
                                                </tr>
                                                <tr>
                                                  <td>إجمالى التأخير</td>
                                                  <td>{{ data.data.main.del }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(data.data.main.del, data.data.total_students) }}%</td>
                                                </tr>
                                              </tbody>
                                          </table>
                                          <div class="row" v-if="data.data.main">
                                            <div class="col-md-3"></div>
                                            <div class="col-md-4">
                                              <apexchart type="donut" width="100%"  :options="chartOptions" :series="[makePerc(data.data.main.pre, data.data.total_students), makePerc(data.data.main.abs, data.data.total_students), makePerc(data.data.main.exc, data.data.total_students), makePerc(data.data.main.del, data.data.total_students)]"></apexchart>
                                            </div>
                                            <div class="col-md-4"></div>
                                          </div>
                                      </div>
                                      <div class="row" v-if="data.data.data">
                                        <div class="col-md-12">
                                          <h3>التفاصيل</h3>
                                        </div>
                                        <div class="col-md-3" v-for="(d,i) in data.data.data" :key="i">
                                          <table class="table table-bordered mb-4">
                                              <thead>
                                                  <tr>
                                                    <th>{{ d.lesson_name }}</th>
                                                    <th>{{ d.teacher ? d.teacher.name : '---' }}</th>
                                                    <th>طالب</th>
                                                    <th>{{ d.total }}</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td>إجمالى الحضور</td>
                                                  <td>{{ d.presence }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(d.presence, d.total) }}%</td>
                                                </tr>
                                                <tr>
                                                  <td>إجمالى الغياب</td>
                                                  <td>{{ d.absence }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(d.absence, d.total) }}%</td>
                                                </tr>
                                                <tr>
                                                  <td>إجمالى الاستأذان</td>
                                                  <td>{{ d.excuse }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(d.excuse, d.total) }}%</td>
                                                </tr>
                                                <tr>
                                                  <td>إجمالى التأخير</td>
                                                  <td>{{ d.delay }}</td>
                                                  <td>طالب</td>
                                                  <td>{{ makePerc(d.delay, d.total) }}%</td>
                                                </tr>
                                              </tbody>
                                          </table>
                                          <apexchart type="donut" width="100%"  :options="chartOptions" :series="[makePerc(d.presence, d.total), makePerc(d.absence, d.total), makePerc(d.excuse, d.total), makePerc(d.delay, d.total)]"></apexchart>

                                        </div>
                                      </div>
                                </div>
                               
                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import * as XLSX from "xlsx";

export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      chartOptions: {
  chart: {
    type: 'donut',
    fontFamily: 'Tahoma',
  },

  labels: [
    'الحضور',
    'الغياب',
    'الاستئذان',
    'التأخير'
  ],

  colors: [
    '#0a8f3c', // أخضر
    '#d32f2f', // أحمر
    '#fbc02d', // أصفر
    '#fb8c00'  // برتقالي
  ],

  plotOptions: {
    pie: {
      donut: {
        size: '72%',
        labels: {
          show: true,

          value: {
            show: true,
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#4a5d23',
            offsetY: -10,
            formatter: (val) => `${val}%`
          },

          name: {
            show: false
          },

          total: {
            show: true,
            label: 'الحضور',
            fontSize: '16px',
            color: '#6b6b6b',
            formatter: (w) => {
              return w.globals.series[0].toFixed(2) + '%'
            }
          }
        }
      }
    }
  },

  dataLabels: {
    enabled: false
  },

  stroke: {
    width: 2
  },

  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
    fontSize: '13px',
    itemMargin: {
      horizontal: 12,
      vertical: 6
    },
    markers: {
      width: 10,
      height: 10
    }
  },

  tooltip: {
    y: {
      formatter: (val) => `${val}%`
    }
  }
},
      printData: {
      },
      data: {
        data: {},
        searching:{
            stage_id: '',
            group_id: '',
            lesson_id: '',
            student_id: '',
            date: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       lessons: [],
       students: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.search(null, '', this, 'stage');
      this.search(null, '', this, 'lesson');
      this.search(null, '', this, 'student');
      this.search(null, '', this, 'group');
  },
  methods: {
    getLabelById(arr, id){
      if(arr.length){
        for (let index = 0; index < arr.length; index++) {
        let element = arr[index];
        if(element.id == id){
          return element.label;
        }
        
      }
      }
      
      return '';
    },
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(){
      setTimeout(() => {
      this.print_element('printMe', ' تقرير التردد اليومى لحضور وغياب الطلاب');

      }, 3000);
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'group');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/reports/absences?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
            loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
              if(type == 'group'){
                this.groups = response.data.data.options;
              }
              if(type == 'lesson'){
                this.lessons = response.data.data.options;
              }
              if(type == 'student'){
                this.students = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },

    getGroups(val){
      this.$baseApi.get('/reports/absences?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    
    getLessons(val, isGroup = true){
      this.$baseApi.get('/reports/absences?pluck=1&stage='+(isGroup ? this.data.searching.stage_id : val.id)+'&i='+(isGroup ? val.id : '')+'&pluckType=lesson').then((response)=>{
            
            if(response.data.code == 200){
              
              this.lessons = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getStudents(val){
      this.$baseApi.get('/reports/absences?pluck=1&lesson='+this.data.searching.lesson_id+'&i='+val.id+'&pluckType=student').then((response)=>{
            
            if(response.data.code == 200){
              
              this.students = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        this.$baseApi.get('/reports/absences?data=' + 1, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
              this.data.data = response.data.data;
              console.log(this.data.data);

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    makePerc(n, t) {
  if (n == 0 || t == 0) {
    return 0;
  }
  return Number(((n / t) * 100).toFixed(2));
},
     exportExcel() {
      const rows = [];

      /* ===================== */
      /* 1️⃣ Report Info */
      /* ===================== */
      rows.push(["اسم التقرير", "تاريخ", "المرحلة الدراسية", "الصف الدراسى", "الحلقة"]);
      rows.push([
        "تقرير التردد اليومى لحضور وغياب الطلاب",
        this.data.searching.date,
        this.getLabelById(this.stages, this.data.searching.stage_id),
        this.getLabelById(this.groups, this.data.searching.group_id),
        this.getLabelById(this.lessons, this.data.searching.lesson_id),
      ]);

      rows.push([]); // spacer

      /* ===================== */
      /* 2️⃣ Summary */
      /* ===================== */
      rows.push(["البيان", "العدد", "الوحدة", "النسبة %"]);

      const total = this.data.data.total_students;
      const main = this.data.data.main;

      rows.push(["إجمالى الطلاب", total, "طالب", "100%"]);
      rows.push(["إجمالى الحضور", main.pre, "طالب", this.makePerc(main.pre, total) + "%"]);
      rows.push(["إجمالى الغياب", main.abs, "طالب", this.makePerc(main.abs, total) + "%"]);
      rows.push(["إجمالى الاستأذان", main.exc, "طالب", this.makePerc(main.exc, total) + "%"]);
      rows.push(["إجمالى التأخير", main.del, "طالب", this.makePerc(main.del, total) + "%"]);

      rows.push([]);
      rows.push(["التفاصيل"]);
      rows.push([]);

      /* ===================== */
      /* 3️⃣ Details Per Lesson */
      /* ===================== */
      this.data.data.data.forEach(d => {
        rows.push([
          "الحلقة",
          d.lesson_name,
          "المعلم",
          d.teacher ? d.teacher.name : "---",
          "إجمالى الطلاب",
          d.total
        ]);

        rows.push(["البيان", "العدد", "الوحدة", "النسبة %"]);
        rows.push(["الحضور", d.presence, "طالب", this.makePerc(d.presence, d.total) + "%"]);
        rows.push(["الغياب", d.absence, "طالب", this.makePerc(d.absence, d.total) + "%"]);
        rows.push(["الاستأذان", d.excuse, "طالب", this.makePerc(d.excuse, d.total) + "%"]);
        rows.push(["التأخير", d.delay, "طالب", this.makePerc(d.delay, d.total) + "%"]);

        rows.push([]); // space between lessons
      });

      /* ===================== */
      /* 4️⃣ Create Excel */
      /* ===================== */
      const ws = XLSX.utils.aoa_to_sheet(rows);

      // RTL support
      ws["!rtl"] = true;

      // Column widths
      ws["!cols"] = [
        { wch: 25 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 }
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "تقرير الحضور");

      XLSX.writeFile(wb, "attendance-report.xlsx");
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
